import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { syncDownloadListFromStorage } from '../state/download-list.actions';
import { DownloadListItem } from '../state/download-list.models';

const DOWNLOAD_LIST_KEY = 'downloadList';

/**
 * Service for synchronizing downloadList between different browser tabs
 * via localStorage events
 */
@Injectable({
  providedIn: 'root',
})
export class DownloadListSyncService {
  private store = inject(Store);

  constructor() {
    this.initStorageListener();
  }

  /**
   * Initializes storage event listener for cross-tab synchronization
   */
  private initStorageListener(): void {
    // Listen for localStorage changes from other tabs
    window.addEventListener('storage', (event: StorageEvent) => {
      // Check if the downloadList key was changed
      if (event.key === DOWNLOAD_LIST_KEY) {
        try {
          // If value is removed (null), the list is empty
          if (event.newValue === null) {
            this.store.dispatch(syncDownloadListFromStorage({ documents: [] }));
          } else {
            // Parse new value and update store
            const updatedDocuments: DownloadListItem[] = JSON.parse(event.newValue);
            this.store.dispatch(syncDownloadListFromStorage({ documents: updatedDocuments }));
          }
        } catch (error) {
          console.warn('Failed to sync downloadList from storage', error);
        }
      }
    });
  }
}
